// pages/Login.js
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  FaCut,
  FaEnvelope,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaArrowRight,
  FaGoogle,
  FaFacebookF,
  FaCalendarCheck,
} from 'react-icons/fa';
import './Auth.css';
import { useToast } from '../../components/Toast';
import { baseurl } from '../Baseurl';

function Login() {
  const navigate = useNavigate();
  const toast = useToast();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const payload = { email, password };
    console.log('Sending login request:', payload);

    try {
      const res = await axios.post(`${baseurl}/auth/login`, payload, {
        withCredentials: true, // needed so the refreshToken httpOnly cookie is set
      });

      console.log('Login response:', res.data);

      const { accessToken, user } = res.data.data;
 

      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('user', JSON.stringify(user));

      toast(res.data.message || 'Login successful', 'success');
 

      setTimeout(() => {
        navigate('/dashboard');
      }, 1000);
    } catch (err) {
      console.log('Login error response:', err.response?.data || err.message);
      toast(err.response?.data?.message || 'Invalid email or password', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-wrapper">
        {/* LEFT PANEL */}
        <div className="auth-visual">
          <div className="visual-top">
            <div className="brand-row">
              <span className="brand-icon-box">
                <FaCut />
              </span>
              <span className="brand-name">Glow & Style</span>
            </div>
            <div className="badge-pill">
              <FaCalendarCheck className="badge-icon" />
              SALON BILLING PLATFORM
            </div>

            <h1 className="visual-heading">
              Welcome <br />
              back to your <br />
              <span>salon dashboard</span>
            </h1>

            <p className="visual-text">
              Manage appointments, billing, and staff in one place.
              Trusted by salons to run smoother, faster, and smarter.
            </p>

            <div className="stats-row">
              <div className="stat-item">
                <h3>8K+</h3>
                <span>Salons Onboard</span>
              </div>
              <div className="stat-item">
                <h3>1.2M+</h3>
                <span>Bills Generated</span>
              </div>
              <div className="stat-item">
                <h3>50+</h3>
                <span>Cities</span>
              </div>
            </div>
          </div>

          <div className="testimonial-box">
            <p>
              "Glow & Style made our daily billing and client management
              effortless. Our front desk runs twice as fast now."
            </p>
            <div className="testimonial-user">
              <div className="avatar">RS</div>
              <div>
                <strong>Riya Sharma</strong>
                <span>Owner, Bliss Salon & Spa</span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="auth-form-side">
          <div className="auth-form-box">
            <div className="form-head">
              <h2>Sign in to your account</h2>
              <p>
                Don't have an account?{' '}
                <Link to="/register">Create one free →</Link>
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <label className="field-label">Email Address</label>
              <div className="input-group">
                <FaEnvelope className="input-icon" />
                <input
                  type="email"
                  placeholder="you@salon.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <label className="field-label">Password</label>
              <div className="input-group">
                <FaLock className="input-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  className="toggle-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              {/* <div className="form-row">
                <label className="remember-me">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />{' '}
                  Remember me
                </label>
                <Link to="/forgot-password" className="forgot-link">
                  Forgot password?
                </Link>
              </div> */}

              <button type="submit" className="auth-btn" disabled={loading}>
                {loading ? (
                  <>
                    <span className="btn-spinner"></span> Signing In...
                  </>
                ) : (
                  <>
                    Sign In <FaArrowRight className="btn-icon" />
                  </>
                )}
              </button>
            </form>

            <p className="auth-switch">
              New to Glow & Style?{' '}
              <Link to="/register">Create a free account</Link>
            </p>

            {/* <p className="fine-print">
              By signing in you agree to our{' '}
              <Link to="/terms">Terms of Service</Link> and{' '}
              <Link to="/privacy">Privacy Policy</Link>.
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;